module.exports = __webpack_public_path__ + "static/media/creativesHead2.71a423ee.jpg";